import { useCallback } from 'react';

import { usePrivateAssetComparisonURLState } from '~/components/AssetModalV2/comparison/hooks/usePrivateAssetComparisonURLState';
import { getEnterAssetComparisonQuery } from '~/constants/assetComparison';
import { type GoToPrivateAssetPageProps, useGoToPrivateAssetPage } from '~/hooks/useGoToPrivateAssetPage';
import { useURLClipIdSelector } from '~/hooks/useURLClipIdSelector';

export type StartPrivateAssetComparisonProps = {
  primaryClip: GoToPrivateAssetPageProps['asset'];
  comparisonClipId: string;
  isAssetModalAlreadyOpen: boolean;
};

/** Starts comparison either within the open modal or while navigating to its primary asset. */
export const useStartPrivateAssetComparison = () => {
  const { goToAssetPage } = useGoToPrivateAssetPage();
  const { startComparison } = usePrivateAssetComparisonURLState();
  const urlClipId = useURLClipIdSelector();

  const startPrivateAssetComparison = useCallback(
    ({ comparisonClipId, isAssetModalAlreadyOpen, primaryClip }: StartPrivateAssetComparisonProps) => {
      if (primaryClip.id === urlClipId) {
        startComparison(comparisonClipId);
        return;
      }

      goToAssetPage({
        asset: primaryClip,
        isAssetModalAlreadyOpen,
        query: getEnterAssetComparisonQuery(comparisonClipId),
      });
    },
    [goToAssetPage, startComparison, urlClipId],
  );

  return { startPrivateAssetComparison };
};
